import MailTokenListStep from './MailTokenListStep';

export default MailTokenListStep;
